import { getMpAgent } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AGREEMENTS_QUERY_KEY } from 'features/Agreements'

export const useCreateErrorReportAgreement = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: any) =>
      getMpAgent().put('/agreements/review', request, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),

    onSuccess: () => {
      queryClient.invalidateQueries([AGREEMENTS_QUERY_KEY.AGREEMENTS])
    },
  })
}
